import { formatDistanceToNowStrict, parseISO } from 'date-fns';

export const getTimePassed = (timestamp?: string) => {
    if (!timestamp) return '';

    const date = parseISO(timestamp);
    return formatDistanceToNowStrict(date);
};
